export default {
  path: 'addresses',
  name: 'vendor/addresses',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "vendor-show-addresses" */ './Addresses')
}
